module.exports = __webpack_public_path__ + "assets/img/lookatwap.4053c010.gif";